exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tooltip__popper {\r\n  max-width: 300px;\n}\r\n", ""]);

// exports
